// Profile avatar lookup.
//
// Today: seed map for the trusted pair (owner + guest), no DB read.
// Tomorrow: a follow-up PR adds `user_profiles.avatar_url` + an
// upload flow; this helper will start preferring the per-user URL
// over the seed fallback. The signature already accepts the merged
// profile row so callers don't change when that lands.
//
// Returns:
//   string — absolute or app-relative URL to the avatar image
//   null   — no avatar known; the caller should render a placeholder
//            (the lucide `User` icon at the same size works well)
//
// The seed map intentionally lives here rather than in owner.js so
// we don't bloat the auth gate module with image asset references.

const SEED = {
  'cb846c7b-e9f3-4d5c-8390-9598c4ae4ece': '/avatars/omar.jpg',
}

export function getAvatarUrl(userId, profile = null) {
  if (!userId) return null
  if (profile?.avatar_url) return profile.avatar_url
  return SEED[userId] || null
}
